import "./prices.css";
import { WrapperComponent, CircularBtn, SectionTitle } from "../../../_imports";
import Links from "../../../../constants/links";

function Prices() {
    const packages = [
        {
            id: 1,
            name: "Teste o app!",
            credits: 10,
            price: 70,
            costPerCredit: 7.00,
            highlight: false
        },
        {
            id: 2,
            name: "O mais usado!",
            credits: 100,
            price: 500,
            costPerCredit: 5.00,
            highlight: true
        },
        {
            id: 3,
            name: "Tem muitas vagas?",
            credits: 500,
            price: 1750,
            costPerCredit: 3.50,
            highlight: false
        }
    ];

    return (
        <section className="prices-section">
            <WrapperComponent>
                <SectionTitle text="NOSSOS PACOTES!" />
                <div className="prices-grid">
                    {packages.map((pkg) => (
                        <div key={pkg.id} className={`price-card ${pkg.highlight ? 'highlight' : ''}`}>
                            {pkg.highlight && <div className="popular-tag">Popular</div>}
                            <h3 className="package-name">{pkg.name}</h3>
                            <div className="package-credits">
                                <span className="credits-amount">{pkg.credits}</span>
                                <span className="credits-label">Créditos</span>
                            </div>

                            <div className="cost-per-credit-highlight">
                                <span className="symbol">R$</span>
                                <span className="value">{pkg.costPerCredit.toFixed(2)}</span>
                                <span className="unit">/crédito</span>
                            </div>

                            <div className="total-price-small">
                                <span>Total: R$ {pkg.price.toFixed(2)}</span>
                            </div>

                            <CircularBtn
                                text="Comprar"
                                link={Links.portal}
                                variant={pkg.highlight ? "candidate" : "company"}
                                className="price-buy-btn"
                            />
                        </div>
                    ))}
                </div>
            </WrapperComponent>
        </section>
    );
}

export default Prices;
